<template>
  <div>
    <nav class="bar bar-nav">
      <a class="icon icon-left pull-left" @click="goBack"></a>
      <h1 class="title">新增发票寄送地址</h1>
    </nav>
    <div class="content">
      <div class="list-block">
        <ul>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">收货人</div>
                <div class="item-input">
                  <input type="text" v-model.trim="expressInfo.consignee" placeholder="姓名">
                </div>
              </div>
            </div>
          </li>
          <li>
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">联系方式</div>
                <div class="item-input">
                  <input type="text" v-model.trim="expressInfo.expressMobile" placeholder="手机号码">
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
              <div class="item-title label">地址</div>
              <div class="item-input">
                <input type="text"  id="city-picker">
              </div>
            </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">详细地址</div>
                <div class="item-input">
                  <textarea v-model.trim="expressInfo.expressAddress"></textarea>
                </div>
              </div>
            </div>
          </li>
          <li class="align-top">
            <div class="item-content">
              <div class="item-inner">
                <div class="item-title label">设为默认</div>
                <div class="item-input" style="margin-top: 1px;margin-left: 45%;">
                  <label class="label-switch">
                    <input type="checkbox"  v-model="expressInfo.isDefaultString">
                    <div class="checkbox"></div>
                  </label>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="content-block">
        <div class="row">
          <div class="col-50"><a @click="goBack" class="button button-big button-fill button-danger">取消</a></div>
          <div class="col-50"><a @click="submit" class="button button-big button-fill button-success">确认</a></div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import $ from 'jquery'
  import {mapState, mapMutations} from 'vuex'
  import emkt from '../../../emkt'

  export default {
    mounted () {
      $('#city-picker').cityPicker({toolbarTemplate: '<header class="bar bar-nav"> <button class="button button-link pull-right close-picker">OK</button> <h1 class="title">choose address</h1> </header>'
      })
    },
    created () {
    },
    data () {
      return {
        expressInfo: {
          consignee: '',
          expressMobile: '',
          expressAddress: '',
          isDefaultString: true,
          province: '',
          city: '',
          district: ''
        },
        error: '',
        href: 'javascript:;'
      }
    },
    computed: {
      ...mapState([
        'sessionInfo'
      ])
    },
    methods: {
      ...mapMutations([
        'INVOICE_ADDRESS'
      ]),
      checkInfo () {
        var _this = this
        var express = $('#city-picker').val()
        if (express === '') {
          _this.error = '地址为空'
          return false
        } else {
          var preexpress = []
          alert(express)
          preexpress = express.split(' ')
          if (preexpress[2] && preexpress[2] !== '') {
            _this.expressInfo.province = preexpress[0]
            _this.expressInfo.city = preexpress[1]
            _this.expressInfo.district = preexpress[2]
          } else {
            _this.expressInfo.city = preexpress[0]
            _this.expressInfo.district = preexpress[1]
          }
        }
        if (_this.expressInfo.consignee === '') {
          _this.error = '收货人姓名为空'
          return false
        }
        if (_this.expressInfo.expressMobile === '' || !/^1[3-9]{1}[0-9]{9}$/.test(_this.expressInfo.expressMobile)) {
          _this.error = '手机号码有误'
          return false
        }
        if (_this.expressInfo.expressAddress === '') {
          _this.error = '地址为空'
          return false
        }
        return true
      },
      submit () {
        var _this = this
        if (_this.checkInfo()) {
          _this.href = 'javascript:window.history.back()'
          let address = _this.expressInfo.expressAddress
          address = address.replace(/"/g, '“').replace(/'/g, '‘').replace(/\s/g, '')
          let params = {}
          params.customerNo = this.sessionInfo.customerInfo.customerNo
          params.creator = this.sessionInfo.customerInfo.customerName
          params.isDefault = _this.expressInfo.isDefaultString === true ? 1 : 0
          params.consignee = _this.expressInfo.consignee.replace(/\s/g, '')
          params.expressMobile = _this.expressInfo.expressMobile
          params.expressAddress = address
          params.province = _this.expressInfo.province
          params.city = _this.expressInfo.city
          params.district = _this.expressInfo.district
          params.addressSource = emkt.ADDRESS_SOURCE.ADDRESS_SOURCE_EMKT
          _this.gcapi('createOrUpdateAddress', params).then((response) => {
            if (response.body.code === 0) {
//              _this.gcapi('gcwwwifc/getUserProfile?ProfileType=4').then((response) => {
//                _this.INVOICE_ADDRESS(response.body.result)
//              })
              $.toast('添加成功')
              _this.goBack()
            } else {
              $.toast('出错')
            }
          })
        } else {
          $.toast(_this.error)
        }
      },
      goBack () {
        this.$router.push({name: 'myInvoiceAddress', query: {from: this.$route.query.from}, params: {order: this.$route.params.order}})
      }
    }
  }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// AddInvoiceAddress.vue?9258b2f4